<template>
  <div v-if="isEditing">
    <el-form-item prop="title" label="题目">
      <wjQuillEditor :content="tempQuesData.title" :config="config" @onChange="handleEditorChange"></wjQuillEditor>
    </el-form-item>
    <el-form-item label="备注">
      <el-input class="editor-input" v-model="tempQuesData.description"></el-input>
    </el-form-item>
  </div>
  <div v-else>
    <div class="ques-title">
      {{ ques.index + 1 }}.
      <p style="display: inline-block;" v-html="ques.title"></p>
      <i v-if="ques.required" class="required-icon">*</i>
    </div>
    <p class="ques-desc">{{ ques.description }}</p>
    <el-cascader :options="options" v-model="selectedRegion" placeholder="选择区域"></el-cascader>
  </div>
</template>
<script>
import wjQuillEditor from "./wj-quill-editor.vue";
export default {
  name: "region",
  data() {
    return {
      options: [],
      selectedRegion: []
    };
  },
  props: ["tempQuesData", "isEditing", "ques", "config"],
  components: {
    wjQuillEditor
  },
  methods: {
    handleEditorChange(data) {
      this.tempQuesData.title = data;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/region.vue